export class Roles {
  idRol!: number;
  name!: string;
  description!: string;
  numberReserva!: number;
  numberAcceso!: number;
}
